const signin = process.env.VUE_APP_API_ROOT?process.env.VUE_APP_API_ROOT:window.location.origin+'/zbs/api/zoom';
const signin_url = signin.replace('api/zoom','sign-in');
// 导出内容
export default {
    signin_url:signin_url,
}
